<template>
	<BaseBanner :condition="productLimits.length > 0">
		<div class="blacklist__content">
			<p v-for="productLimit in productLimits">
				{{ productLimit }}
			</p>

			<p>
				In order to complete your purchase, please reduce the number of these products or remove them
				from your <a style="color: #0D6EFD; text-decoration: underline" href="/cart">cart</a> and checkout.
			</p>
		</div>
	</BaseBanner>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseBanner from './index.vue';

export default {
	components: { BaseBanner },
	computed: {
		...mapGetters('checkout', ['productLimits']),
	},
};
</script>
